// extracted by mini-css-extract-plugin
export default {"faqHowBuildRating":"faqHowBuildRating_ZedEj","title":"title_Rp1uS","list":"list_oGzmb"};